<template>
    <v-card outlined class="primary white--text">
        <div class="primary darken-1 pa-4">
            <div class="subtitle-1 font-weight-medium">
                <span>Your goals in <span class="title">{{lapse}}</span> years</span>
            </div>
        </div>

        <v-card-text class="pt-6 px-6 pb-7 white--text" v-if="loaded">
            <div v-for="(item, index) in model" :key="item.id">
                <div class="d-flex align-center justify-space-between">
                    <div class="d-flex align-start">
                        <div class="title mr-2">{{index+1}}.</div>
                        <div v-if="!validateIsEmpty(item.goal)">
                            <div class="title font-weight-regular">{{item.goal}}</div>
                            <div class="mt-n2" style="opacity:.5; font-size:11px">{{item.type.toUpperCase()}} GOAL</div>
                        </div>
                        <div v-else>
                            <div class="subtitle-1 mt-1 font-weight-medium" style="opacity:.4">PENDING...</div>
                        </div>
                    </div>

                    <v-btn class="white primary--text" :disabled="validateIsEmpty(item.goal)" @click="$emit('track', {item:item, index:index})">Track</v-btn>
                </div>

                <v-divider class="my-4" v-if="index<model.length-1"></v-divider>
            </div>

            <v-divider class="mt-6"></v-divider>

            <div class="mt-6 text-center">
                <v-btn outlined class="white--text" @click="$emit('edit')">
                    Edit goals
                </v-btn>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import Helpers from '@/services/helpers'
import _ from 'lodash'

export default {
    data: () => ({
        loaded: false,
        model: [
            {
                goal: '',
                type: 'professional', // professional | personal
            },
            {
                goal: '',
                type: 'professional', // professional | personal
            },
            {
                goal: '',
                type: 'professional', // professional | personal
            },
            {
                goal: '',
                type: 'professional', // professional | personal
            },
            {
                goal: '',
                type: 'professional', // professional | personal
            },
            {
                goal: '',
                type: 'professional', // professional | personal
            }
        ]
    }),
    props: ['goals', 'lapse'],
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (this.goals['t'+this.lapse].goals) {
                _.merge(this.model, this.goals['t'+this.lapse].goals);
            }  
            
            this.loaded = true;
        }
    }
}
</script>